import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { ENABLE_PINK_DUCKS, MARKETING_ANALYTICS_TARGET_URL, PINK_DUCKS_RATIOS, PINK_DUCKS_URL } from '~/modules/config';
import { ChannelNotSupportedYetError } from '~/modules/errors/channelErrors';
import { AnalyticsTarget } from './analyticsTarget';
import { MarketingAnalyticsEventTypeFactory } from './marketingAnalyticsEventTypes/marketingAnalyticsEventTypeFactory';
import { MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes/marketingAnalyticsEventTypes';

export class MarketingAnalytics implements AnalyticsTarget {
    url: string = MARKETING_ANALYTICS_TARGET_URL;
    pinkDucksUrl: string = PINK_DUCKS_URL;
    pinkDuckRatio = new Map<string, number>([
        [AnalyticsEventTopic.ANALYTICS_CLICK, 0.045],
        [AnalyticsEventTopic.ANALYTICS_LOAD_IMPRESSION, 0.0017],
        [AnalyticsEventTopic.ANALYTICS_CAROUSEL_SHOWN_IMPRESSION, 0.026],
        [AnalyticsEventTopic.ANALYTICS_CHAT_INIT, 0.02],
        [AnalyticsEventTopic.ANALYTICS_SHOWN_IMPRESSION, 0.0054],
        [AnalyticsEventTopic.ANALYTICS_PAGE_LOAD, 0.0425],
        [AnalyticsEventTopic.ANALYTICS_USER_ACTIVITY, 0.935],
        [AnalyticsEventTopic.ANALYTICS_LEAD_EVENT, 0.99],
        [AnalyticsEventTopic.ANALYTICS_USER_INSTALL, 0.935],
    ]);

    constructor() {
        // This will overwrite values for the pink duck ratios.
        // I would suggest only using this for testing new values.
        // If you want the ratio to be permanent please edit the ratio object above.
        this.setPinkDuckRatios(PINK_DUCKS_RATIOS);
    }

    setPinkDuckRatios(pinkDuckConfigInput: string) {
        try {
            if (!ENABLE_PINK_DUCKS || !pinkDuckConfigInput) {
                return;
            }
            const pinkDuckRatioConfig = JSON.parse(pinkDuckConfigInput);
            for (const [key, value] of Object.entries(pinkDuckRatioConfig)) {
                const ratio: number = value as number;
                if (ratio !== null && ratio <= 1 && ratio >= 0 && this.pinkDuckRatio.has(key)) {
                    this.pinkDuckRatio.set(key, ratio);
                }
            }
        } catch (e) {
            // this is client side so just do nothing as we will use default values
        }
    }
    // @ts-expect-error * Automated Type Error Fix
    postEvent(event): Promise<any> {
        try {
            const eventType: MarketingAnalyticsEventType = new MarketingAnalyticsEventTypeFactory().getEventTypeHandler(
                event,
            );

            if (eventType) {
                const maEvent = eventType.getBody(event);

                if (ENABLE_PINK_DUCKS) {
                    const ratio = this.pinkDuckRatio.get(maEvent.topic);
                    maEvent.trace = ratio !== undefined && ratio >= Math.random();
                }

                const postRequest = new Blob([JSON.stringify(maEvent)], { type: 'text/plain' });
                navigator.sendBeacon(this.url, postRequest);

                if (ENABLE_PINK_DUCKS && maEvent.trace) {
                    navigator.sendBeacon(this.pinkDucksUrl, postRequest);
                }
            }
            return Promise.resolve();
        } catch (e: unknown) {
            if (e instanceof ChannelNotSupportedYetError) {
                return Promise.resolve();
            }

            throw e;
        }
    }
}
